<template>
  <footer class="footer" :style="backgroundStyle">
    <div class="container margin-divider" v-show="shouldShowWorkSection">
      <div class="grid">
        <h3
          class="item special-h3 hover"
          v-for="(work, index) in works"
          :key="work.name"
          v-bind:class="{ selected: isSelected[index] }"
        >
          <router-link :to="work.code">{{ work.name }}</router-link>
        </h3>
      </div>
    </div>
    <div class="container">
      <hr class="solid" />
    </div>
    <div class="container">
      <div class="footer-item">
        <img class="social-icon" :src="linkedin" @click="goTo('linkedin')" />
        <img class="social-icon" :src="behance" @click="goTo('behance')" />
        <img class="social-icon" :src="instagram" @click="goTo('ins')" />
      </div>
      <div
        class="footer-item copy-right"
        :style="isMobileDevice ? 'margin:0;' : 'margin:0 120px 0 0;'"
      >
        &copy; {{ year }} {{ $t("footer.copyright") }}
        <a v-if="isCN" class="icp" @click="goTo('icp')">
          ICP证: XXXXXXXXXX
        </a>
      </div>
      <div class="footer-item ">
        <a class="bottom-a" @click.prevent="setLocale('en')">En</a>
        <a class="bottom-a"> | </a>
        <a class="bottom-a" @click.prevent="setLocale('cn')">中</a>
      </div>
    </div>
  </footer>
</template>

<script>
import Vue from "vue";
export default {
  props: {
    backgroundColor: String,
    shouldShowWorkSection: Boolean,
    instagram: {
      type: String,
      default: require("@/assets/img/common/instagram.png")
    },
    linkedin: {
      type: String,
      default: require("@/assets/img/common/linkedin.png")
    },
    behance: {
      type: String,
      default: require("@/assets/img/common/behance.png")
    }
  },
  data() {
    return {
      isMobileDevice: this.$isMobile,
      isCN: false,
      isSelected: [false, false, false, false, false, false, false],
      year: new Date().getFullYear()
    };
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.$router.push({
        params: { lang: locale }
      });
    },
    goTo(website) {
      if (website === "ins") {
        window.open("https://www.instagram.com/yingying.niur", "_blank");
      } else if (website === "linkedin") {
        window.open("https://www.linkedin.com/in/yingyingchen1120/", "_blank");
      } else if (website === "behance") {
        window.open("https://www.behance.net/stellachen1120", "_blank");
      }
    }
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundColor: `${this.backgroundColor}`
      };
    },
    works() {
      return [
        { name: this.$i18n.t("footer.all"), code: `/${this.$i18n.locale}` },
        { name: this.$i18n.t("footer.discovery"), code: "discovery" },
        { name: this.$i18n.t("footer.avatar"), code: "avatar" },
        { name: this.$i18n.t("footer.system"), code: "system" },
        { name: this.$i18n.t("footer.sfdw"), code: "sfdw" },
        { name: this.$i18n.t("footer.concert"), code: "concert" },
        { name: this.$i18n.t("footer.vr_game"), code: "astrounaut" }
      ];
    }
  },
  watch: {
    $route(to, from) {
      for (let [index, work] of this.works.entries()) {
        if (to.name === work.code) {
          Vue.set(this.isSelected, index, true);
        } else {
          Vue.set(this.isSelected, index, false);
        }
      }
      if (this.$i18n.locale === "en") {
        this.isCN = false;
      } else {
        this.isCN = true;
      }
    }
  },
  mounted() {
    if (this.$i18n.locale === "en") {
      this.isCN = false;
    } else {
      this.isCN = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.margin-divider {
  margin-top: 5rem;
  margin-bottom: 5rem;
}
.copy-right {
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-style: normal;
  font-weight: normal;
  line-height: 30px;
  font-weight: 500;
  color: gray;
  font-size: 1rem;
}
.social-icon {
  width: 60px;
  height: auto;
  padding-left: 0px;
  padding-right: 26px;
  cursor: pointer;
}
.language {
  text-align: center;
  margin-right: auto;
}
.hover {
  a:hover {
    color: #00b695 !important;
  }
}
.icp {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  line-height: 30px;
  font-weight: 500;
  color: gray;
  font-size: 1rem;
  text-align: center !important;
  font-variant: small-caps;
  margin: auto;
}
</style>
